<div class="slider-container">
    <div class="close" (click)="closePopup()">&times;</div>
    <!-- <owl-carousel-o [options]="customOptions" id="property_slide_2" #owlCar>
        <ng-template carouselSlide *ngFor="let property_images of project_image;let i = index" [id]="property_images.RefID + i">
            <img [src]="property_images" alt="" class="slider-image">
        </ng-template>
    </owl-carousel-o> -->sdfsfd
</div>